// The FAQ, as data. FAQPage renders it and scripts/prerender-meta.mjs reads it
// at build time so the questions and answers are in the raw HTML for crawlers.
//
// RULE (2026-09-06): only things that are true today. No policies that haven't
// been decided (refunds, cancellations, kids), no amenities that aren't in the
// spec (towels, climate control, Sonos), no "credits", no "Digital Wall". If a
// question needs an answer we don't have yet, it waits.
//
// Keep strings double-quoted; the prerender regex depends on it.

export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQSection {
  title: string;
  items: FAQItem[];
}

export const faqSections: FAQSection[] = [
  {
    title: "Getting started",
    items: [
      {
        question: "What is Maslow?",
        answer: "Twelve private restrooms in SoHo, New York, wrapped around a free room called the Hull. You book a room by the session, on your phone or at the door. The Hull is free to everyone. No purchase, no questions.",
      },
      {
        question: "When does it open?",
        answer: "2028 is the target. The legal work and a presale come first, then a lease, then the build. When there's a date, it will be here.",
      },
      {
        question: "Where?",
        answer: "SoHo first. Other neighborhoods after the first one works.",
      },
      {
        question: "Do I need the app?",
        answer: "No. Book on the website, or walk up and book at the door. The app is there if you want it, in thirteen languages.",
      },
    ],
  },
  {
    title: "The rooms",
    items: [
      {
        question: "What's in a room?",
        answer: "Every room is the same: a wall-hung Toto toilet with a bidet and a handheld sprayer, a vanity with a lit mirror, an artificial skylight, a bench, a fold-down changing table, a foot basin, and a locking sliding door. Money buys minutes, never a better room.",
      },
      {
        question: "Are the rooms wheelchair accessible?",
        answer: "Every one of them. There is no separate accessible room, so nobody waits for it.",
      },
      {
        question: "Can I nurse, pump, or pray there?",
        answer: "Yes. Nursing and pumping supplies and a garment steamer are set up before you arrive when you choose them at booking, at no charge. Every room has a foot basin for washing before prayer, and there are prayer rugs and a place to pray in the Hull.",
      },
      {
        question: "How are the rooms cleaned?",
        answer: "Between every guest. The toilet cleans itself, staff wipe it down and restock from a service door behind the wall, and the room is marked ready. Nobody walks through your room while you're in it.",
      },
      {
        question: "Is it safe?",
        answer: "The door opens from the inside no matter what, even with the power out. Every room has a call button that ends the session and brings staff. There are no cameras or microphones inside any room. Cameras cover the Hull and the entrances.",
      },
    ],
  },
  {
    title: "Booking and paying",
    items: [
      {
        question: "How does pricing work?",
        answer: "By the session, starting at ten minutes for less than the price of a macchiato. Longer sessions cost more and come with samples. No membership required. Full pricing goes up before we open.",
      },
      {
        question: "Do I need to book ahead?",
        answer: "No. Walk up when a room is free, or book ahead to hold a time.",
      },
      {
        question: "How long can I stay?",
        answer: "Sessions are ten, twenty or thirty minutes. The two Pro rooms, built for stylists and barbers, book by the hour, the block, or the day.",
      },
      {
        question: "How do I pay?",
        answer: "Cards, Apple Pay and Google Pay, through Stripe.",
      },
      {
        question: "Can I buy before you open?",
        answer: "Not yet. A presale of visits and bricks opens once the sales agreement is signed. The waitlist hears first.",
      },
    ],
  },
  {
    title: "Your account",
    items: [
      {
        question: "How do I change my email or delete my account?",
        answer: "There is no password. You sign in with a code texted to your phone, and your email lives in Settings in the app. To delete your account and everything tied to it, email hello@maslow.nyc with \"Account Deletion Request\" in the subject line and it's done within 30 days.",
      },
      {
        question: "How is my data handled?",
        answer: "Encrypted and stored with standard practices. We don't sell it. The Privacy Policy has the details.",
      },
    ],
  },
];
